import { css } from '@emotion/react'

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 4px;
`

export const error = css`
  text-align: left;
  margin-top: 4px;
  width: 100%;
`
export const button = css`
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  font-size: inherit;
  padding: 0;
  margin: 0;
  text-decoration: underline;
  margin-left: 4px;
`
